import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoComponent } from './video.component';
import { DetailModule } from '../detail/detail.module';

@NgModule({
  declarations: [VideoComponent],
  imports: [
    CommonModule,
    DetailModule
  ]
})
export class VideoModule { }
